<template>
  <div>
    <el-form :model="form" :rules="rules" ref="ruleForm">
      <el-form-item label="维度" prop="dimension">
        <el-radio-group v-model="form.dimension" @input="handleDimensionChange">
          <el-radio :label="1">商品</el-radio>
          <el-radio :label="2">产品</el-radio>
          <el-radio :label="3" v-if="isAll">包件</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="类型" prop="planType" v-if="form.dimension < 3">
        <el-radio-group v-model="form.planType">
          <el-radio :label="1">预估量</el-radio>
          <el-radio :label="2">预估调整量</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="月份" prop="month">
        <el-row type="flex">
          <el-checkbox v-model="checkAll" @change="handleCheckAllChange">所有</el-checkbox>
          <el-checkbox-group v-model="form.month" @change="handleMonthChange" style="margin-left: 15px;">
            <el-checkbox :label="item" v-for="item in monthData" :key="item">{{item}}月</el-checkbox>
          </el-checkbox-group>
        </el-row>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import mixin from '@/views/preSalePlan/utils/mixin.js'
export default {
  mixins: [mixin],
  props: ['isAll','formData'],
  data() {
    return {
      monthData: [],
      form: {
        month: [],
      },
      checkAll: false,
      rules: {
        dimension: [
          { required: true, message: '不能为空', trigger: 'change' }
        ],
        month: [
          { required: true, message: '不能为空', trigger: 'change' }
        ],
        planType: [
          { required: true, message: '不能为空', trigger: 'change' }
        ]
      }
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    // 月份分数
    async init() {
      let data = {
        planTime: this.planTime.split('-')[0],
        storeId: this.storeId
      };
      let res = await this.$q.preSalePlan.planProductGrade({data})
      if(res.success && res.data) {
        // this.monthData = res.data.filter(v=>v['isSub'] === true).map(v=>v['monthNum']);
        this.monthData = res.data.map(v=>v['monthNum']);
      }else{
        this.monthData = [];
      }
    },
    handleDimensionChange(data) {
      if(data === 3) {
        this.rules.planType[0].required = false;
        this.$refs['ruleForm'].clearValidate('planType');
      }else {
        this.rules.planType[0].required = true;
      }
    },
    handleMonthChange(data) {
      if(data.length === 4){
        this.checkAll = true;
      }else{
        this.checkAll = false;
      }
    },
    handleCheckAllChange(status) {
      if(status) {
        this.form.month = this.monthData
      }else{
        this.form.month = [];
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
  >>> .el-form-item__content, >>> .el-form-item__label
    height 32px
    line-height 32px
</style>